const initMenu = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.main-nav__toggle');

    if (btn) {
      e.preventDefault();

      const menu = btn.closest('.main-nav');
      const header = document.querySelector('.header');

      if (header) {
        header.classList.toggle('header--white');
      }

      menu.classList.toggle('is-menu-show');

      if (menu.classList.contains('is-menu-show')) {
        window.scrollLock.disableScrolling();
      } else {
        window.scrollLock.enableScrolling();
      }
    }
  });

};

export {initMenu};
